module.exports = __webpack_public_path__ + "static/media/8.42083c8a.jpg";